import { Avatar, Stack, Typography } from '@mui/material';
import { getGeneralOptions } from 'API/generalOptions/generalOptions';
import { ControlledSelectInput2 } from 'Components';
import { ControlledTextField } from 'Components/ControlledTextField';
import { OTPLoginContext } from 'Context/OTPLoginContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { UniversalRequestPurpleExclamationMark } from 'Images';
import { useContext, useEffect, useState } from 'react';

const phonePrefixLength = 3,
  phoneNumberLength = 8,
  phonePrefixStart = '0';

export const ContactDetails = () => {
  const { userDetails, setUserDetails, errors, setErrors } =
    useContext(OTPLoginContext);
  const [phonePrefixes, setPhonePrefixes] = useState<{
    ids: string[];
    values: string[];
  }>({ ids: [''], values: [''] });

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.OTP_Login
  ).personalDetailsForm;

  useEffect(() => {
    (async () => {
      const result = await getGeneralOptions();
      if (result) {
        const prefixesIds: string[] = [];
        const prefixesValues: string[] = [];
        result.general.phonePrefixes.map((prefix, index) => {
          if (
            prefix.value.length === phonePrefixLength &&
            prefix.value.charAt(0) === phonePrefixStart
          ) {
            prefixesIds.push(prefix.id.toString());
            prefixesValues.push(prefix.value);
          }
          return null;
        });
        setPhonePrefixes({ ids: prefixesIds, values: prefixesValues });
        setUserDetails({
          ...userDetails,
          phonePrefix: userDetails.phonePrefix || phonePrefixes.ids[0] || '050',
        });
      }
    })();
  }, []);

  return (
    <Stack direction='column' gap='16px' mb='56px'>
      <Typography variant={'body1'} tabIndex={0} component='h1'>
        {dictionary.contactDetails[0] + ' ' + dictionary.contactDetails[1]}
      </Typography>
      <Stack
        direction='row-reverse'
        alignItems='center'
        gap='24px'
        width='100%'
      >
        <ControlledSelectInput2
          value={userDetails.phonePrefix || phonePrefixes.values[0] || ''}
          options={phonePrefixes.values}
          onChange={(e) => {
            setUserDetails({
              ...userDetails,
              phonePrefix: e.target.value,
            });
          }}
          ariaLabelledById={dictionary.phonePrefix}
          size={'small'}
          sx={{
            maxWidth: '110px',
            '& fieldset': {
              mt: '3px',
            },
          }}
        />
        <ControlledTextField
          label={dictionary.phoneNumber}
          ariaLabel={dictionary.phoneNumber}
          ariaRequired
          type='tel'
          value={userDetails.phoneNumber}
          setValue={(value: string) =>
            setUserDetails({ ...userDetails, phoneNumber: value })
          }
          showError
          inputLimit={phoneNumberLength}
          inputRegexType='PHONE'
          error={errors.phoneNumber}
          setError={(error: string | null) =>
            setErrors({ ...errors, phoneNumber: error })
          }
        />
      </Stack>
      <ControlledTextField
        label={dictionary.email}
        ariaLabel={dictionary.email}
        ariaDescribe={dictionary.emailNotMandatory}
        value={userDetails.email}
        type='email'
        setValue={(value: string) =>
          setUserDetails({ ...userDetails, email: value })
        }
        showError
        inputRegexType='EMAIL'
        error={errors.email}
        setError={(error: string | null) =>
          setErrors({ ...errors, email: error })
        }
      />
      <Stack
        direction='row'
        alignItems='flex-start'
        justifyContent='flex-start'
        gap='12px'
      >
        <Avatar
          sx={{ width: '20px', height: '20px', mt: '3px' }}
          src={UniversalRequestPurpleExclamationMark}
          alt={''}
        />
        <Typography
          variant={'body3'}
          sx={{
            maxWidth: '47ch',
          }}
        >
          {dictionary.emailNotMandatory}
        </Typography>
      </Stack>
    </Stack>
  );
};
